/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const solana_chain_about = () => `Solana stands out as a high-performance blockchain, celebrated for its scalability, speed, and minimal transaction expenses. Featuring a distinctive consensus mechanism dubbed Proof of History (PoH), Solana achieves remarkable scalability and efficiency. Tailored to accommodate dApps, it excels in processing a vast number of transactions swiftly, thereby slashing processing durations and fees. These attributes make it a compelling platform for developers within the cryptocurrency realm.`
